import { KlipyGifDto } from "./KlipyGifDto";
import { KlipyGifModel } from "./KlipyGifModel";

export const transformKlipyGifDtoToModel = (
  dto: KlipyGifDto
): KlipyGifModel | null => {
  const preview =
    dto.file?.xs?.gif ||
    dto.file?.sm?.gif ||
    dto.file?.md?.gif ||
    dto.file?.hd?.gif;

  const send =
    dto.file?.hd?.gif ||
    dto.file?.md?.gif ||
    dto.file?.sm?.gif ||
    dto.file?.xs?.gif;

  const id = dto.id != null ? String(dto.id) : dto.slug;

  if (!id || !preview?.url || !send?.url) {
    return null;
  }

  return {
    id,
    slug: dto.slug || "",
    title: dto.title || dto.slug || "",
    previewUrl: preview.url,
    send,
  };
};
